<template>
  <div>
    <div class="background">
      <img src="../assets/images/login_bg.png" class="back_img">
    </div>

    <div class="login">
      <div style="width: 690px; margin-left: 155px">
        <h1 style="color: white; font-size: 40px">
          欢迎登录Python函数参数传递可视化虚拟仿真实验
        </h1>
      </div>
      <div style="background-color: white; padding: 10px; width: 500px; margin-left: 245px">
        <h1>
          用户登录
        </h1>
        <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row class="username">
            <el-col :span="24">
              <el-input
                class="class_account inputUserInfo"
                placeholder="请输入用户名"
                prefix-icon="el-icon-user"
                v-model="ruleForm.username" >
              </el-input>
            </el-col>
          </el-row>

          <el-row class="h20">
            <el-col :span="24">
              <el-input
                class="class_account inputUserInfo"
                placeholder="请输入密码"  prefix-icon="el-icon-lock" v-model="ruleForm.password" show-password></el-input>
            </el-col>
          </el-row>

          <!-- <el-row class="h15">
             <el-col :span="24">
               <el-radio v-model="ruleForm.radio" label="0">学生</el-radio>
               <el-radio v-model="ruleForm.radio" label="1">管理员</el-radio>
             </el-col>
           </el-row>-->

          <el-row class="h7">
            <el-col :span="24">
              <el-link type="danger">{{ msg }}</el-link>
            </el-col>
          </el-row>
          <el-row class="h7">
            <el-col :span="24">
              <el-button type="primary" class="class_account logBtn" @click="submitForm('ruleForm')">登录</el-button>
            </el-col>
          </el-row>

          <el-row class="h15">
            <el-col :span="24">
              <el-link type="primary" @click="toRegister">还没账号，立即注册</el-link>
            </el-col>
          </el-row>

        </el-form>
      </div>


    </div>
  </div>
</template>

<script>
import { loginAddress } from '../request/api';

export default {
  name: 'LOGIN',
  data () {
    return {
      msg:"",
      ruleForm: {
        username: "",
        password: "",
        radio: "1"
      }

    }
  },
  methods: {
    toRegister() {
      // 跳转到注册页面
      this.$router.push('/register');
    },
    submitForm() {
      if (this.ruleForm.username === '') {
        this.msg = "用户名不能为空";
        return false;
      }
      if (this.ruleForm.password === '') {
        this.msg = "密码不能为空";
        return false;
      }
      let param = {
        userName: this.ruleForm.username,
        password: this.ruleForm.password,
        userType: this.ruleForm.radio
      }
      // 管理员页面
      // 提交登录请求
      loginAddress(param).then(
        resp => {
          if (resp.code === 1) {
            this.msg = "登录成功";
            localStorage.setItem("token",resp.data.authToken)
            if (param.userType === '1') {
              // 管理员页面
              this.$router.push('/admin');
            } else {
              // 管理员页面
              this.$router.push('/admin');
              // 学生页面
              //this.$router.push('/flexTest');
              //this.$router.push({name:"FrontPage",params:resp.data.userInfo})
            }
          } else {
            this.msg = resp.msg;
            this.$message.error(resp.msg);
          }
        }
      ).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  h1{
    font-size: 25px;
    margin-top: 50px;
  }
  .background {
    border-radius: 1px;
    width: 100%;
    height: 100%;
    z-index:-1;
    position: absolute;
  }
  .login{
    border-radius: 2px;
    width: 1000px;
    height: 400px;

    z-index:1;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -300px;
    margin-left: -500px;
  }
  .back_img {
    width: 100%;
    height: 100%;
  }
  .class_account{
    width: 300px;
  }
  .username{
    margin-top: 50px;
  }
  .inputUserInfo .el-input__inner {
    border-radius: 50px;
  }

  .h7{
    margin-top: 7px;
  }
  .h15{
    margin-top: 15px;
  }
  .h20{
    margin-top: 20px;
  }
  .login .el-input {
    width: 300px
  }


</style>



// WEBPACK FOOTER //
// src/components/Login.vue